import React, { useState } from "react";

export default function DisplayScoreBatAPI(props) {
  const { videos } = props;
  const [query, setQuery] = useState("");

  return (
    <>
      <div
        className="search-filter"
        style={{
          margin: "auto",
          display: "block",
          width: "235px",
          padding: "15px",
          position: "fixed",
          top: "0",
        }}
      >
        <input
          className="form-control my-2 my-lg-0"
          type="search"
          placeholder="Search"
          aria-label="Search"
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>
      <div className="container">
        {videos
          .filter((data) => {
            if (query === "") {
              return data;
            } else if (
              data.title.toLowerCase().includes(query.toLocaleLowerCase())
            )
              return data;
              else return false;
          })
          .map((data, key) => (
            <div key={key} className="card-container">
              <a href={data.url}>
                <img
                  alt="img"
                  src={data.thumbnail}
                  style={{ width: "500px", height: "350px" }}
                />
              </a>
              <p>{data.title}</p>
            </div>
          ))}
      </div>
    </>
  );
}
